module.exports = "/assets/career/hero/hero.png?0iFNY39";